// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"6119008b","156":"987a3ebf","292":"52f87c49","457":"d24a8ba0","551":"8a809239","842":"8729baef","851":"846286ef"}[chunkId] + ".chunk.js";
};